import type { RequestPayload } from "@inertiajs/core";
import { router } from "@inertiajs/react";
import { ObservationForm } from "../../components/observation/ObservationForm";
import { getFullName } from "../../helpers/stringHelper";
import { useYearContext } from "../../hooks/useYearContext";
import { ContentShell } from "../../layout/ContentShell";
import type { Observation } from "../../models/observation";
import { observation_path, observations_apprentice_path } from "../../routes";

type ObservationEditProps = {
  observation: Observation;
};

export default function ObservationEdit({ observation }: ObservationEditProps) {
  const { pathWithYearContext } = useYearContext();
  const onSubmit = (values: RequestPayload) => router.patch(pathWithYearContext(observation_path, observation.id), values);
  return (
    <ContentShell
      title={`Beobachtung: ${getFullName(observation.apprentice)}`}
      onBack={() => router.get(pathWithYearContext(observations_apprentice_path, observation.apprentice.id))}
    >
      <ObservationForm saveButtonLabel="Speichern" observation={observation} onSubmit={onSubmit} />
    </ContentShell>
  );
}
